import { BackgroundInfoTopic } from './background-info-topic';
import { BackgroundInfoJurisdiction } from './background-info-jurisdiction';

export class BackgroundInfo {
  backgroundInfoId: number;
  jurisdiction?: BackgroundInfoJurisdiction;
  topics: BackgroundInfoTopic[];
}
